import { render } from "react-dom";
import { BrowserRouter as ReactRouterDomBrowserRouter } from "react-router-dom";
import { createGlobalStyle } from "styled-components";

import "./services/app";

import { App } from "./App";
import reportWebVitals from "./reportWebVitals";

/** Viewports this width and below get horizontal pan/scroll for clipped layouts (phones). */
const MOBILE_LAYOUT_MAX_PX = 639;

const GlobalStyle = createGlobalStyle`
  html {
    -webkit-text-size-adjust: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    height: 100%;
  }

  body {
    margin: 0;
    min-height: 100%;
    min-height: 100dvh;
    height: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
  }

  #root {
    margin: 0;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    width: 100%;
    max-width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
  }

  @media (max-width: ${MOBILE_LAYOUT_MAX_PX}px) {
    html {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    body {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    #root {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
  }

  * {
    box-sizing: border-box;
  }

  .game-form-modal .ant-modal-header,
  .stadium-form-modal .ant-modal-header,
  .section-form-modal .ant-modal-header,
  .snaps-create-event-modal .ant-modal-header {
    font-family: "Montserrat", sans-serif;
  }
  .game-form-modal .ant-modal-title,
  .stadium-form-modal .ant-modal-title,
  .section-form-modal .ant-modal-title,
  .snaps-create-event-modal .ant-modal-title {
    font-family: "Montserrat", sans-serif;
    font-weight: 600;
    font-size: 18px;
  }
  .snaps-create-event-modal .ant-modal-content {
    border-radius: 18px;
    overflow: hidden;
    box-shadow:
      0 20px 50px rgba(15, 23, 42, 0.18),
      0 8px 20px rgba(15, 23, 42, 0.08);
  }
  .snaps-create-event-modal .ant-modal-close {
    top: 18px;
    right: 18px;
    color: #64748b;
  }
  .snaps-create-event-modal .ant-modal-close:hover {
    color: #0f172a;
  }

  .team-form-modal .ant-modal-header,
  .team-ad-modal .ant-modal-header {
    font-family: "Montserrat", sans-serif;
  }
  .team-form-modal .ant-modal-title,
  .team-ad-modal .ant-modal-title {
    font-family: "Montserrat", sans-serif;
    font-weight: 600;
    font-size: 18px;
  }
` as any;
const BrowserRouter = ReactRouterDomBrowserRouter as any;

render(
  <BrowserRouter>
    <GlobalStyle />
    <App />
  </BrowserRouter>,
  document.getElementById("root"),
);

reportWebVitals();
